module.exports = __webpack_public_path__ + "assets/img/es-86090039.png";